export default __webpack_public_path__ + "static/Tori-69d877cbf0ad282cec291b09764130df077144c12b8c56da7a647aef522bb20f.svg";